import { combineEpics } from 'redux-observable';
import { filter, mergeMap, tap } from 'rxjs/operators';

import { CLIENT_PORTAL_URL } from '../../env';
import { Services } from '../../services';
import { gotoClientPortal, gotoVerifyApp, gotoCreditApp } from '../../store/actions/route';
import { RootEpic } from '../../store/epics';
import { isEmbedded } from '../../utils/embedded';

const gotoClientPortalEpic: RootEpic = (action$, _state$, { window }: Services) => {
  return action$.pipe(
    filter(gotoClientPortal.match),
    tap(() => {
      if (isEmbedded()) {
        window.open(CLIENT_PORTAL_URL, '_blank');
      } else {
        window.location.replace(CLIENT_PORTAL_URL);
      }
    }),
    mergeMap(() => []),
  );
};

const gotoVerifyAppEpic: RootEpic = (action$, state$, { window }: Services) => {
  return action$.pipe(
    filter(gotoVerifyApp.match),
    tap(() => {
      window.location.replace(state$.value.config.config!.verifyAppUrl);
    }),
    mergeMap(() => []),
  );
};

const gotoCreditAppEpic: RootEpic = (action$, state$, { window }: Services) => {
  return action$.pipe(
    filter(gotoCreditApp.match),
    tap(() => {
      window.location.replace(state$.value.config.config!.creditAppUrl);
    }),
    mergeMap(() => []),
  );
};

export const gotoPortalEpic = combineEpics(gotoClientPortalEpic, gotoVerifyAppEpic, gotoCreditAppEpic);
